import { createFileRoute } from '@tanstack/react-router';
import { Section, SectionEyebrow } from '../components/Section.js';
import { usePageTitle } from '../components/usePageTitle.js';

export const Route = createFileRoute('/legal')({
  component: LegalPage,
});

const documents = [
  {
    title: 'Privacy Policy',
    summary: 'What we collect, why we collect it, how long we keep it, and how you can access or correct it.',
    href: '/privacy',
    live: true,
  },
  {
    title: 'Terms of Service',
    summary: 'The agreement between you and Bookaburra — plans, billing, acceptable use, and liability.',
    href: '/terms',
    live: true,
  },
  {
    title: 'Data Processing Addendum',
    summary: 'For businesses subject to the Australian Privacy Act, GDPR, or similar regimes.',
    href: null,
    live: false,
  },
  {
    title: 'Acceptable Use Policy',
    summary: "The detailed rules for what you can and can’t do with a Bookaburra account.",
    href: null,
    live: false,
  },
];

function LegalPage() {
  usePageTitle('Legal');

  return (
    <>
      <section className="bg-brand-cream">
        <div className="mx-auto max-w-6xl px-6 pb-16 pt-14 sm:px-12 sm:pt-20">
          <div className="inline-flex items-center gap-2 rounded-full bg-brand-cream-shadow px-3 py-1 text-xs font-semibold uppercase tracking-widest text-brand-sage ring-1 ring-brand-sage/15">
            Legal
          </div>
          <h1 className="mt-6 max-w-3xl text-4xl font-extrabold leading-[1.05] tracking-tightest text-brand-ink-soft sm:text-6xl">
            The fine print, kept plain.
          </h1>
          <p className="mt-7 max-w-2xl text-lg text-brand-ink-soft/80 sm:text-xl">
            We write these to be read, not to obscure. If anything is unclear,
            email us.
          </p>
        </div>
      </section>

      <Section tone="shadow">
        <SectionEyebrow>Legal documents</SectionEyebrow>
        <ul className="mt-8 grid gap-5 sm:grid-cols-2">
          {documents.map((doc) => (
            <li key={doc.title}>
              {doc.live && doc.href ? (
                <a
                  href={doc.href}
                  className="group block rounded-2xl border border-brand-sage/15 bg-brand-cream p-7 shadow-[0_30px_80px_-30px_rgba(19,33,36,0.06)] transition-shadow hover:shadow-[0_30px_80px_-30px_rgba(19,33,36,0.14)]"
                >
                  <h2 className="text-xl font-semibold text-brand-ink-soft group-hover:text-brand-sage transition-colors">
                    {doc.title} &rarr;
                  </h2>
                  <p className="mt-3 text-base text-brand-ink-soft/75">
                    {doc.summary}
                  </p>
                </a>
              ) : (
                <div className="rounded-2xl border border-dashed border-brand-sage/30 bg-brand-cream p-7">
                  <h2 className="text-xl font-semibold text-brand-ink-soft">
                    {doc.title}
                  </h2>
                  <p className="mt-3 text-base text-brand-ink-soft/75">
                    {doc.summary}
                  </p>
                  <p className="mt-6 text-xs font-semibold uppercase tracking-widest text-brand-ink-soft/40">
                    Coming soon
                  </p>
                </div>
              )}
            </li>
          ))}
        </ul>
        <p className="mt-12 max-w-2xl text-sm text-brand-ink-soft/60">
          Questions?{' '}
          <a
            href="mailto:hello@bookaburra.com"
            className="text-brand-sage underline-offset-4 hover:underline"
          >
            hello@bookaburra.com
          </a>
        </p>
      </Section>
    </>
  );
}
